import auth from '../helper/auth'

const userRoutes = [

    {
        path: '/login',
        name: 'Login',
        //beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/SignIn.vue')
    },
    {
        path: '/signup',
        name: 'SignUp',
        //beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/SignUp.vue')
    },
    {
        path: '/signin',
        name: 'SignIn',
        beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/SignIn.vue')
    },

    {
        path: '/password-reset',
        name: 'PasswordReset', //beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/PasswordReset.vue')
    },
    {
        path: '/password-reset/token/:token',
        name: 'PasswordResetNew', //beforeEnter: auth.ifNotAuthenticated,
        component: () => import('../views/PasswordResetNew.vue')
    },

    {
        path: '/account-not-found',
        name: 'AccountNotFound',
        component: () => import('../views/AccountNotFound.vue')
    },

    {
        path: '/*',
        name: 'PageNotFound',
        component: () => import('../views/PageNotFound.vue')
    },
]

export default userRoutes